// Backwards-compatible toast wrapper.
//
// The app previously had two toast systems: this custom DOM-based one and
// `sonner` (used directly in a handful of files). This module now routes the
// legacy `toast({ title, description, variant })` API through Sonner so every
// toast in the app renders through the single <Toaster /> mounted in App.tsx —
// one consistent look, no import changes needed at call sites.
import { toast as sonnerToast } from 'sonner';

type ToastType = {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success' | 'warning' | 'info';
  duration?: number;
};

export const toast = ({ title, description, variant = 'default', duration = 4000 }: ToastType) => {
  const opts = { description, duration };
  switch (variant) {
    case 'destructive':
      return sonnerToast.error(title, opts);
    case 'success':
      return sonnerToast.success(title, opts);
    case 'warning':
      return sonnerToast.warning(title, opts);
    case 'info':
      return sonnerToast.info(title, opts);
    default:
      return sonnerToast(title, opts);
  }
};

// Re-export Sonner's toast for callers that want the richer API directly.
export { sonnerToast };
